<template>

    <div>
        <table class="table table-borderless">
            <tr>
                <th>Name</th>
                <th>Title</th>
                <th>Email</th>
                <th>Cell</th>
                <th>Phone</th>
                <th></th>
            </tr>
            <tr v-for="cc in contacts">
                <td> {{ cc.name }} {{ cc.last_name }}</td>
                <td> {{ getField(cc, 'position.name') }}</td>
                <td> {{ getField(cc, 'email') }}</td>
                <td><a :href="`tel:${cc.cell}`">{{ cc.cell }}</a></td>
                <td><a :href="`tel:${cc.phone}`">{{ cc.phone }}</a></td>
                <td></td>
            </tr>
            <tr v-if="!is_contact">
                <td colspan="6"><a href="#" @click.prevent.stop="showModal" class="btn btn-success btn-sm">+</a></td>
            </tr>
            <tr v-if="is_contact">
                <td> {{ contact.name }}

                    <span  v-if="is_contact && contact.notes" class="ml-2" data-trigger="hover" data-toggle="popover" data-html="true"
                          data-placement="bottom" style="cursor: pointer"
                          title="Notes"
                          :data-content='`${contact.notes}`'>
                        <i class="fa fa-info text-info"></i>
                    </span>
                </td>
                <td>{{ contact.title }}
                </td>
                <td> {{ contact.email }}</td>
                <td><a :href="`tel:${contact.cell}`">{{ contact.cell }}</a></td>
                <td><a :href="`tel:${contact.phone}`">{{ contact.phone }}</a></td>
                <td>
                    <a class="btn btn-info" @click.prevent.stop="editContact()"><span
                        class="fa fa-edit text-white"></span></a>
                    <a class="btn btn-danger" @click.prevent.stop="deleteContact()"><span
                        class="fa fa-trash text-white"></span></a>
                </td>
            </tr>

        </table>

        <modal-default size="sm" active-back-drop ref="addModal" show-footer title="CONTACT">
            <div class="form-row">
                <div class="form-group col-md-12">
                    <label>Contact Name
                        <required-field></required-field>
                    </label>
                    <input class="form-control" v-model="contact_name">
                </div>

                <div class="form-group col-md-12">
                    <label>Title</label>
                    <input class="form-control" v-model="contact_title">
                </div>


                <div class="form-group col-md-12">
                    <label>Phone</label>
                    <input class="form-control" v-model="contact_phone">
                </div>

                <div class="form-group col-md-12">
                    <label>Cell</label>
                    <input class="form-control" v-model="contact_cell">
                </div>

                <div class="form-group col-md-12">
                    <label>Email</label>
                    <input class="form-control" v-model="contact_email">
                </div>


                <div class="form-group col-md-12">
                    <label>Notes</label>
                    <textarea rows="8" class="form-control" v-model="notes"></textarea>
                </div>
            </div>
            <template v-slot:actions>
                <button type="button" class="btn btn-primary text-xs font-weight-bold mt-2"
                        @click="dispatchWorkTicket().then((r) => {})"> SAVE CONTACT TO THIS TICKET
                </button>
            </template>
        </modal-default>
    </div>

</template>
<script>

import _ from "lodash";
export default {
    name: "ScheduleDispatchContact",
    props: {
        dateId: String,
        contacts: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            contact_name: '',
            contact_phone: '',
            contact_email: '',
            contact_title: '',
            contact_cell: '',
            notes: '',
            is_contact: false,
            contact: null
        }
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            let app = this;
            axios.get('/api/work_orders/dispatch/schedule-date/' + this.dateId,)
                .then((response) => {
                    let date = response.data.data;
                    if (date.contact_name) {
                        app.contact = {
                            name: date.contact_name,
                            phone: date.contact_phone,
                            email: date.contact_email,
                            title: date.contact_title,
                            cell: date.contact_cell,
                            notes: date.notes,
                        }

                        app.is_contact = true;
                        $(function () {
                            $('[data-toggle="popover"]').popover();
                        });
                    }
                })
                .catch(error => {
                    this.$loading(false);
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {
                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);


                })
        },
        dispatchWorkTicket() {

            if (!this.contact_name) {
                showMessage('e', 'Contact Name is required!');
                return;
            }

            /*    if (!this.contact_phone) {
                    showMessage('e', 'Phone is required!');
                    return;
                }

                if (!this.notes) {
                    showMessage('e', 'Notes is required!');
                    return;
                }*/
            let app = this;

            axios.post('/api/work_orders/dispatch/schedule-date/' + this.dateId + '/save-contact', {
                contact_name: this.contact_name,
                contact_phone: this.contact_phone,
                contact_email: this.contact_email,
                contact_title: this.contact_title,
                contact_cell: this.contact_cell,
                notes: this.notes,
            })
                .then((response) => {
                    app.loadData();
                    app.$refs.addModal.hide();

                })
                .catch(error => {
                    this.$loading(false);
                    let message = '';
                    if (_.has(error, 'response.data.friendly_message')) {

                        message = error.response.status + ' - ' + error.response.data.friendly_message;

                    } else if (_.has(error, 'response.status')) {

                        message = 'Request failed with status code ' + error.response.status;

                    } else {
                        message = 'Application failed with error: ' + error.message;
                        console.log(error);
                    }

                    showMessage('w', message);


                })
        },
        showModal() {
            this.$refs.addModal.show();
        },

        deleteContact() {
            let app = this;
            if (confirm('Are you sure?')) {
                axios.post('/api/work_orders/dispatch/schedule-date/' + this.dateId + '/save-contact', {
                    contact_name: '',
                    contact_phone: '',
                    contact_email: '',
                    contact_title: '',
                    contact_cell: '',
                    notes: '',
                })
                    .then((response) => {
                        app.is_contact = false;
                        app.contact = null;
                        app.loadData();
                    })
                    .catch(error => {
                        this.$loading(false);
                        let message = '';
                        if (_.has(error, 'response.data.friendly_message')) {

                            message = error.response.status + ' - ' + error.response.data.friendly_message;

                        } else if (_.has(error, 'response.status')) {

                            message = 'Request failed with status code ' + error.response.status;

                        } else {
                            message = 'Application failed with error: ' + error.message;
                            console.log(error);
                        }

                        showMessage('w', message);
                    });
            }
        },
        editContact() {
            this.contact_name = this.contact.name
            this.contact_phone = this.contact.phone
            this.contact_email = this.contact.email
            this.contact_cell = this.contact.cell
            this.contact_title = this.contact.title
            this.notes = this.contact.notes
            this.showModal()
        },
        getField(object, field) {
            return _.get(object, field)
        }
    }
}
</script>
<style scoped>
.table td, .table th {
    padding: 0rem;
    vertical-align: top;
    border-top: 1px solid #dee2e6;
}
</style>
